<template>
  <el-drawer title="发起审批" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="出发城市：" prop="formProvinceId" class="row-form-item">
        <el-select v-model="addForm.formProvinceId" filterable clearable placeholder="选择省份" @change="provinceIdChange($event, 'form')">
          <el-option v-for="item in province" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
        </el-select>
        <div class="gap"></div>
        <el-form-item prop="fromCityId">
          <el-select v-model="addForm.fromCityId" filterable clearable placeholder="选择城市" :disabled="!addForm.formProvinceId" value-key="fromCityId">
            <el-option v-for="item in formCity" :key="item.areaId" :label="item.areaName" :value="{ fromCityId: item.areaId, fromCityName: item.areaName }" />
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="到达城市：" prop="endProvinceId" class="row-form-item">
        <el-select v-model="addForm.endProvinceId" filterable clearable placeholder="选择省份" @change="provinceIdChange($event, 'end')">
          <el-option v-for="item in province" :key="item.areaId" :label="item.areaName" :value="item.areaId" />
        </el-select>
        <div class="gap"></div>
        <el-form-item prop="endCityId">
          <el-select v-model="addForm.endCityId" filterable clearable placeholder="选择城市" :disabled="!addForm.endProvinceId" value-key="endCityId">
            <el-option v-for="item in endCity" :key="item.areaId" :label="item.areaName" :value="{ endCityId: item.areaId, endCityName: item.areaName }" />
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="单程往返：" prop="travelType">
        <el-radio-group v-model="addForm.travelType">
          <el-radio :label="1">单程</el-radio>
          <el-radio :label="0">往返</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="交通工具：" prop="transportation" class="otherTransportation">
        <el-radio-group v-model="addForm.transportation">
          <el-radio label="飞机">飞机</el-radio>
          <el-radio label="火车">火车</el-radio>
          <el-radio label="汽车">汽车</el-radio>
          <el-radio label="其他">其他</el-radio>
        </el-radio-group>
        <el-form-item v-if="addForm.transportation === '其他'" prop="otherTransportation">
          <el-input v-angle="addForm.otherTransportation" v-model="addForm.otherTransportation" placeholder="请输入您乘坐的交通工具" maxlength="14" clearable />
        </el-form-item>
      </el-form-item>
      <el-form-item label="开始日期：" prop="beginTime">
        <el-date-picker
          v-model="addForm.beginTime"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始日期"
          style="width: 100%"
          @change="beginTimeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期：" prop="endTime">
        <el-date-picker
          v-model="addForm.endTime"
          type="date"
          :disabled="!addForm.beginTime"
          :picker-options="pickerOptionsDate(addForm.beginTime, 'only')"
          :default-value="defaultDatePickerDate(addForm.beginTime)"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择结束日期"
          style="width: 100%"
          @change="endTimeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="出差时长：" prop="travelTime" class="el-form-flex">
        <el-input v-angle="addForm.travelTime" v-model="addForm.travelTime" disabled placeholder="根据开始日期、结束日期，系统自动计算" class="flex-1" />
        <span style="margin-left: 8px">天</span>
      </el-form-item>
      <el-form-item label="出差事由：" prop="travelReason">
        <el-input v-angle="addForm.travelReason" v-model="addForm.travelReason" placeholder="填写出差事由" :rows="4" maxlength="70" type="textarea" show-word-limit clearable />
      </el-form-item>
      <el-form-item label="附件：" prop="annexUrl" label-width="73px" style="margin-left: 10px">
        <el-upload
          class="flex items-start flex-column"
          accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf"
          :action="`/api/estate/v1/common/uploadFile?token=${token}&communityId=0`"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          multiple
          :limit="3"
        >
          <el-button size="small" type="primary" class="mr-8">选择附件</el-button>
        </el-upload>
        <div class="el-upload__tip">最多3个，不超过2M，格式为jpg/jpeg/png/doc/docx/xls/xlsx/pdf</div>
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { getToken } from '@/utils/auth'
import { submitFlowTravelApply } from '@/api/workflow'
import { areaProvinceDropList, areaChildrenDropList } from '@/api/dropList'
import formatData from '@/utils/formatRequestData'
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        formProvinceId: '',
        fromCityId: '',
        fromCityName: '',
        endProvinceId: '',
        endCityName: '',
        endCityId: '',
        travelType: '',
        transportation: '',
        otherTransportation: '',
        beginTime: '',
        endTime: '',
        travelTime: '',
        travelReason: '',
        annexUrl: [],
      },
      fileList: [],
      rules: {
        formProvinceId: [{ required: true, message: '出发省份不能为空', trigger: 'change' }],
        fromCityId: [{ required: true, message: '出发城市不能为空', trigger: 'change' }],
        endProvinceId: [{ required: true, message: '目的省份不能为空', trigger: 'change' }],
        endCityId: [{ required: true, message: '目的不能为空', trigger: 'change' }],
        travelType: [{ required: true, message: '单程往返不能为空', trigger: 'change' }],
        transportation: [{ required: true, message: '交通工具不能为空', trigger: 'change' }],
        otherTransportation: [{ required: true, message: '交通工具不能为空', trigger: 'change' }],
        beginTime: [{ required: true, message: '开始日期不能为空', trigger: 'change' }],
        endTime: [{ required: true, message: '结束日期不能为空', trigger: 'change' }],
        travelTime: [{ required: true, message: '出差时长不能为空', trigger: 'change' }],
        travelReason: [{ required: true, message: '出差事由不能为空', trigger: 'change' }],
      },
      endCity: [],
      formCity: [],
      province: [],
    }
  },
  watch: {
    drawer(val) {
      if (!val) return this.resetForm()
      this.areaProvinceDropList()
    },
  },
  computed: {
    token() {
      return getToken()
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const format = formatData(this.addForm)
      if (format.transportation == '其他') format.transportation = format.otherTransportation
      const { data: res } = await submitFlowTravelApply(format)

      if (!res) return this.$message.error('发起失败')
      this.$message.success('发起成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    // 开始日期
    beginTimeChange(e) {
      this.handlerDateIsAfter(this.addForm, 'beginTime', 'endTime')
      if (!e || !this.addForm.endTime) return (this.addForm.travelTime = '')
      this.addForm.travelTime = this.handlerDateDiff(this.addForm.beginTime, this.addForm.endTime)
    },

    endTimeChange(e) {
      if (!e || !this.addForm.beginTime) return (this.addForm.travelTime = '')
      this.addForm.travelTime = this.handlerDateDiff(this.addForm.beginTime, this.addForm.endTime)
    },

    handlerDateDiff(beginTime, endTime) {
      const begin = new Date(beginTime).getTime()
      const end = new Date(endTime).getTime()
      const diff = end - begin
      const day = diff / (1000 * 60 * 60 * 24)
      return day
    },

    // 移除上传的文件
    handleRemove(file, fileList) {
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    handleSuccess(res, file, fileList) {
      if (res.errCode !== 0) {
        this.handleRemove(file, fileList)
        return this.$message.error(res.errMsg)
      }
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    // 获取省份
    async areaProvinceDropList() {
      const { data: res } = await areaProvinceDropList({})
      this.province = res || []
    },

    // 获取市、区、县
    async areaChildrenDropList(value, type) {
      const { data: res } = await areaChildrenDropList(value)
      if (type === 'end') this.endCity = res || []
      if (type === 'form') this.formCity = res || []
    },

    provinceIdChange(e, type) {
      if (type === 'form') {
        this.addForm.fromCityId = ''
        this.addForm.fromCityName = ''
      } else {
        this.addForm.endCityId = ''
        this.addForm.endCityName = ''
      }
      if (!e) return
      this.areaChildrenDropList(
        {
          parentId: e,
        },
        type
      )
    },
  },
}
</script>
<style lang="less" scoped>
.row-form-item {
  ::v-deep .el-form-item__content {
    display: flex;
    margin-left: 0px !important;
  }
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}
.gap {
  width: 8px;
}
::v-deep .el-upload {
  width: auto !important;
  height: auto !important;
  border: none !important;
}
.el-upload__tip {
  color: #606266 !important;
  margin-top: 0 !important;
}
::v-deep .el-radio {
  margin-right: 0px !important;
}
.otherTransportation {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}
</style>
